import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ProductSetupsService } from '../../../product-setups/core/services/ProductSetupsService';
import { IOpenSetupStep } from '../../../product-setups/core/interfaces/IProductSetupWidgets';
import { formatSetupWaiting } from '../../core/utils/formatSetupWaiting';

@Component({
  selector: 'app-open-setup-steps-chart',
  templateUrl: './open-setup-steps-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OpenSetupStepsChartComponent implements OnInit {

  public items: IOpenSetupStep[] = [];
  public isLoading = false;
  public failed = false;

  private readonly _productSetupsService = inject(ProductSetupsService);
  private readonly _cdr = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this.isLoading = true;
    this.failed = false;

    this._productSetupsService.open()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this._cdr.markForCheck();
        })
      )
      .subscribe({
        next: res => this.items = res,
        error: () => {
          this.items = [];
          this.failed = true;
        }
      });
  }

  public waiting(waitingSince: string): string {
    return formatSetupWaiting(waitingSince);
  }
}
